import type { FormEvent } from 'react';
import React from 'react';

import { FormField, FormHelp, Input, Label, Text, Textarea } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import { PERSON, RECYCLING_PROCEDURES } from '../../../constants';
import type { HTMLElementEvent } from '../../../models/Types';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function RecyclingProcedure_v2({ section, setSectionValues }: Props): JSX.Element {
  function onContainerLocationChange(event: FormEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [RECYCLING_PROCEDURES.FIELD_NAME.CONTAINER_LOCATION]: value,
    });
  }

  function onPickupScheduleChange(event: FormEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [RECYCLING_PROCEDURES.FIELD_NAME.PICKUP_SCHEDULE]: value,
    });
  }

  function onServiceProviderChange(event: FormEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER]: value,
    });
  }

  function onPhoneNumberChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER_PHONE_NUMBER]: value,
    });
  }

  return (
    <>
      <Text fontType="h6">Recycling</Text>
      <FormField
        marginTop="xs"
        label={<Label>Where are the containers located?</Label>}
        control={
          <Textarea
            onChange={onContainerLocationChange}
            value={section.getFieldValue(RECYCLING_PROCEDURES.FIELD_NAME.CONTAINER_LOCATION)}
            resize="vertical"
          />
        }
      />
      <FormField
        marginTop="xs"
        label={<Label>What is the pickup schedule?</Label>}
        control={
          <Textarea
            onChange={onPickupScheduleChange}
            value={section.getFieldValue(RECYCLING_PROCEDURES.FIELD_NAME.PICKUP_SCHEDULE)}
            resize="vertical"
          />
        }
      />
      <FormField
        marginTop="xs"
        label={<Label>What service provider?</Label>}
        control={
          <Input
            onChange={onServiceProviderChange}
            value={section.getFieldValue(RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER)}
          />
        }
      />
      <FormField
        marginTop="xs"
        label={<Label>What is the provider’s phone number?</Label>}
        control={
          <Input
            value={section.getFieldValue(RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER_PHONE_NUMBER)}
            onChange={onPhoneNumberChange}
            type="tel"
          />
        }
        error={section
          .getField(RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER_PHONE_NUMBER)
          .showOnError(PERSON.ERROR_MESSAGE.PHONE_NUMBER)}
        description={
          section
            .getField(RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER_PHONE_NUMBER)
            .showOnError(PERSON.ERROR_MESSAGE.PHONE_NUMBER) && (
            <FormHelp error>
              {section
                .getField(RECYCLING_PROCEDURES.FIELD_NAME.PROVIDER_PHONE_NUMBER)
                .showOnError(PERSON.ERROR_MESSAGE.PHONE_NUMBER)}
            </FormHelp>
          )
        }
      />
    </>
  );
}
